<template>
  <MessagePopup
    :visible="$store.getters.showDeleteDevicePopup"
    :extra-classes="['message-popup--delete']"
  >
    <template v-slot:content>
      Möchtest du dieses Gerät wirklich löschen?
    </template>
    <template v-slot:actions>
      <button
        class="button button--secondary"
        @click="$store.commit('hideDeleteDevicePopup')"
      >
        Nein
      </button>
      <button class="button button--primary" @click="deleteDevice(device)">
        Ja
      </button>
    </template>
  </MessagePopup>
</template>

<script>
  import MessagePopup from '@/components/MessagePopup'

  export default {
    name: 'delete-device-popup',
    props: {
      device: {
        type: Object,
        required: true,
      },
    },
    components: {
      MessagePopup,
    },
    methods: {
      async deleteDevice() {
        this.$store.dispatch('deleteDevice', this.device.id)
        this.$router.push({ name: 'devices' })
        this.$store.commit('showDeleteDevicePopup', false)
      },
    },
  }
</script>

<style lang="scss"></style>
